export default {
  namespaced: true,
  state: {
    items: [],
    current: 0
  },
  mutations: {
    addBanner(state, payload) {
      state.items.push(payload)
    },
  },
  actions: {
    initBanner({ commit }, payload) {
      commit('addBanner', payload)
    },
  },
  getters: {
    state: state => state
  }
}
